module.exports = __webpack_public_path__ + "img/file-download-black-24-dp.b2fa188e.svg";